import { BalanceSolicitation } from "@/models/balanceSolicitation.model";
import { axiosInstance } from "./axiosInstance";
import { removeNonDigits } from "@/utils/cpfFormatter";

export const createBalanceSolicitation = async (
  document: string,
  processorName: string,
  name?: string,
  phone?: string
): Promise<BalanceSolicitation> => {
  try {
    const response = await axiosInstance.post("/api/balance-solicitation", {
      document,
      processorName,
      name: name || "",
      phone: phone || "",
      origin: "SELFSERVICE",
    });

    return response.data;
  } catch (error) {
    console.error("Erro ao criar solicitação de saldo:", error);
    throw error;
  }
};

export const getBalanceSolicitations = async (): Promise<
  BalanceSolicitation[]
> => {
  try {
    const response = await axiosInstance.get(`/api/balance-solicitation/user`);

    return response.data;
  } catch (error) {
    console.error("Erro ao obter Propostas:", error);
    throw error;
  }
};

export const getBalanceSolicitationById = async (
  balanceSolicitationId: string | undefined
): Promise<BalanceSolicitation | null> => {
  if (!balanceSolicitationId) return null;

  try {
    const response = await axiosInstance.get(
      `/api/balance-solicitation/${balanceSolicitationId}`
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter o balance solicitation:", error);
    throw error;
  }
};

export const cleanBalanceSolicitation = async (
  balanceSolicitationIds: string[]
): Promise<BalanceSolicitation | null> => {
  try {
    const response = await axiosInstance.put(
      `/api/balance-solicitation/corban`,
      balanceSolicitationIds
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao limpar consultas:", error);
    throw error;
  }
};

export const getLastBalanceSolicitationByDocumentId = async (
  document: string,
  selfServiceId: string
): Promise<BalanceSolicitation | null> => {
  const cpf = removeNonDigits(document);
  try {
    const response = await axiosInstance.get(
      `/api/balance-solicitation/latest`,
      { params: { cpf, selfServiceId } }
    );

    return response.data;
  } catch (error) {
    console.error("Erro ao obter o balance solicitation:", error);
    return null;
  }
};
